export const detectProjectTaskIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete task" || cleaned === "remove task") {
        return { intent: "delete_task" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) task/);
    if (deleteMatch) {
        return { intent: "delete_task", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create task") || cleaned.includes("add task")) {
        return { intent: "create_task" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create task named (.+)/);
    if (createMatch) {
        return { intent: "create_task", name: createMatch[1].trim() };
    }

    return null;
};
